import { type ComponentPropsWithRef, memo } from 'react';

export const IconAskNow = memo<ComponentPropsWithRef<'svg'>>((props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.79718 3.31342C10.2319 2.50401 11.0762 1.99902 11.995 1.99902C12.9137 1.99902 13.7581 2.50401 14.1928 3.31342L16.1311 6.86084C16.3608 7.28257 16.7073 7.62905 17.129 7.8587L20.6764 9.79706C21.4858 10.2317 21.9908 11.0761 21.9908 11.9949C21.9908 12.9136 21.4858 13.758 20.6764 14.1927L17.129 16.131C16.7073 16.3607 16.3608 16.7072 16.1311 17.1289L14.1928 20.6763C13.7581 21.4857 12.9137 21.9907 11.995 21.9907C11.0762 21.9907 10.2319 21.4857 9.79718 20.6763L7.85883 17.1289C7.62918 16.7072 7.28269 16.3607 6.86096 16.131L3.31354 14.1927C2.50413 13.758 1.99915 12.9136 1.99915 11.9949C1.99915 11.0761 2.50413 10.2317 3.31354 9.79706L6.86096 7.8587C7.28269 7.62905 7.62918 7.28257 7.85883 6.86084L9.79718 3.31342Z"
			fill="#101010"
		/>
	</svg>
));
